import { API_ENDPOINTS, API_HEADERS } from "../constants/api";
import type { BlogApiPost } from "./blogService";

export interface BlogPostsResult {
  posts: BlogApiPost[];
  totalCount: number;
}

interface PaginatedNewsletterResponse {
  total?: number;
  results?: BlogApiPost[];
}

const mapResponseToResult = (data: unknown): BlogPostsResult => {
  if (Array.isArray(data)) {
    return { posts: data, totalCount: data.length };
  }
  const paginated = data as PaginatedNewsletterResponse;
  if (Array.isArray(paginated?.results)) {
    return {
      posts: paginated.results,
      totalCount:
        typeof paginated.total === "number"
          ? paginated.total
          : paginated.results.length,
    };
  }
  return { posts: [], totalCount: 0 };
};

export interface FetchNewsletterPostsParams {
  page?: number;
  pageSize?: number;
}

export const fetchNewsletterPosts = async (
  params: FetchNewsletterPostsParams = {}
): Promise<BlogPostsResult> => {
  const url = new URL(API_ENDPOINTS.newsletterPosts);
  if (params.page) {
    url.searchParams.set("page", params.page.toString());
  }
  if (params.pageSize) {
    url.searchParams.set("pageSize", params.pageSize.toString());
  }
  const response = await fetch(url.toString(), {
    headers: API_HEADERS,
  });
  if (!response.ok) {
    throw new Error(
      `Newsletter posts request failed with status ${response.status}`
    );
  }
  const data: unknown = await response.json();
  return mapResponseToResult(data);
};
